import React, { useEffect, useState } from 'react';

import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';

import VimeoWidget from '~/components/Common/Forms/widgets/VimeoWidget';

interface Props {
  open: boolean;
  videoId?: string;
  onClose: () => void;
  onSave: (videoId: string) => void;
}

export default function VideoEditorDialog({ open, videoId, onClose, onSave }: Props) {
  const [draftVideoId, setDraftVideoId] = useState('');

  useEffect(() => {
    if (open) {
      setDraftVideoId(videoId ?? '');
    }
  }, [open, videoId]);

  const handleSave = () => {
    onSave(draftVideoId.trim());
    onClose();
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>Replace video</DialogTitle>
      <DialogContent>
        <VimeoWidget value={draftVideoId} onChange={setDraftVideoId} />
      </DialogContent>
      <DialogActions>
        <Button variant="text" onClick={onClose}>
          Cancel
        </Button>
        <Button variant="contained" onClick={handleSave}>
          Save video
        </Button>
      </DialogActions>
    </Dialog>
  );
}
